import React, { useState } from 'react';

export default function ConfirmDeliveryScreen() {
  // OTP code state
  const [code, setCode] = useState(['', '', '', '']);
  const [activeIndex, setActiveIndex] = useState(0);

  // Handle key input
  const handleKeyPress = (key) => {
    const newCode = [...code];

    if (key === 'delete') {
      // Delete last filled slot
      for (let i = 3; i >= 0; i--) {
        if (newCode[i] !== '') {
          newCode[i] = '';
          setActiveIndex(i);
          break;
        }
      }
    } else {
      // Fill next empty slot
      for (let i = 0; i < 4; i++) {
        if (newCode[i] === '') {
          newCode[i] = key;
          setActiveIndex(i + 1 <= 3 ? i + 1 : 3);
          break;
        }
      }
    }

    setCode(newCode);
  };

  const keyboardKeys = [
    ['q', 'w', 'e', 'r', 't', 'y', 'u', 'i', 'o', 'p'],
    ['a', 's', 'd', 'f', 'g', 'h', 'j', 'k', 'l'],
    ['?', 'z', 'x', 'c', 'v', 'b', 'n', 'm', '?'],
  ];

  return (
    <div className="min-h-screen bg-[#F1F3F2] flex flex-col max-w-md mx-auto relative">
      {/* Status Bar */}
      <div className="bg-[#F1F3F2] text-black px-5 pt-3 pb-2 flex justify-between items-center text-sm font-semibold">
        <span>10:33</span>
        <div className="flex items-center gap-2">
          <svg width="18" height="14" viewBox="0 0 18 14" fill="currentColor">
            <rect x="0" y="10" width="3" height="4" rx="0.5" />
            <rect x="5" y="7" width="3" height="7" rx="0.5" />
            <rect x="10" y="3" width="3" height="11" rx="0.5" />
            <rect x="15" y="0" width="3" height="14" rx="0.5" />
          </svg>
          <svg width="18" height="14" viewBox="0 0 18 14" fill="none" stroke="currentColor" strokeWidth="1.5">
            <path d="M1 5C5 1 13 1 17 5" strokeLinecap="round" />
            <path d="M5 8.5C7.5 6 10.5 6 13 8.5" strokeLinecap="round" />
            <circle cx="9" cy="12" r="1" fill="currentColor" stroke="none" />
          </svg>
          <svg width="24" height="14" viewBox="0 0 24 14" fill="currentColor">
            <rect x="0" y="1" width="20" height="12" rx="2" stroke="currentColor" strokeWidth="1.5" fill="none" />
            <rect x="2" y="3" width="14" height="8" rx="1" />
            <path d="M22 5V9C23 8.5 23 5.5 22 5Z" />
          </svg>
        </div>
      </div>

      {/* Main Content */}
      <div className="flex-1 bg-[#F1F3F2] px-6 pt-16 pb-8 flex flex-col items-center">
        <h1 className="text-xl font-bold text-black text-center mb-12 leading-relaxed">
          Input your delivery confirmation code
        </h1>

        {/* OTP Input Boxes */}
        <div className="flex gap-4 mb-16">
          {code.map((digit, index) => (
            <div
              key={index}
              className={`w-16 h-16 bg-[#F1F3F2] border-2 border-black rounded-md flex items-center justify-center text-2xl font-bold ${
                activeIndex === index ? 'ring-2 ring-[#19C463]' : ''
              }`}
            >
              {digit !== '' ? digit : '0'}
            </div>
          ))}
        </div>

        {/* Confirm Button */}
        <button className="w-full bg-[#19C463] text-white text-base font-bold py-3.5 rounded-md mt-auto mb-8">
          Confirm
        </button>
      </div>

      {/* Keyboard */}
      <div className="bg-gray-700 px-2 pb-6 pt-2">
        {keyboardKeys.map((row, rowIndex) => (
          <div key={rowIndex} className="flex justify-center gap-1.5 mb-2">
            {row.map((key, keyIndex) => (
              <button
                key={keyIndex}
                onClick={() => {
                  if (key === '?') {
                    handleKeyPress('delete');
                  } else if (key !== '?') {
                    handleKeyPress(key);
                  }
                }}
                className={`bg-gray-500 text-white text-base font-medium rounded-md flex items-center justify-center ${
                  key === '?' || key === '?' ? 'w-12' : 'w-8'
                } h-10 active:bg-gray-400`}
              >
                {key}
              </button>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
